
export const getTeamMemberLimit = (plan: string): number => {
  switch (plan) {
    case 'starter':
      return 3;
    case 'enterprise':
      return 5;
    case 'free':
    default:
      return 1;
  }
};

export const calculateAdditionalMembersNeeded = (
  currentMemberCount: number,
  plan: string
): number => {
  const limit = getTeamMemberLimit(plan);
  return Math.max(0, currentMemberCount - limit);
};

export const calculateAdditionalMembersCost = (additionalMembers: number): number => {
  return additionalMembers * 10; // $10 per additional member
};

export const canAddTeamMember = (
  currentMemberCount: number,
  plan: string,
  hasAdditionalMembersSubscription: boolean = false
): boolean => {
  const limit = getTeamMemberLimit(plan);
  
  if (plan === 'free') {
    return currentMemberCount < limit;
  }
  
  // For starter and enterprise, can always add if they're willing to pay
  return true;
};
